import React from 'react';
// import ReactDOM from 'react-dom';
import { render } from 'react-snapshot';
import App from './App';

var VERSION = 'v1.0';
console.log(`%c🌶%c\nSITE BY LACH.IO%c\nVERSION: ${VERSION}`,
    'font-size: 120px',
    'font-size: 12px; font-family: helvetica, sans-serif; font-weight: bold;',
    'font-size: 9px; font-family: helvetica, sans-serif; color: grey;'
);

render(
	// sheet.collectStyles(
		<App/>
	// )
, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js